import { useMemo } from 'react';
import { useGetServiceConnectionsQuery } from '../../../../redux/api/fymAPI';
import { ArtistPortalCardState, artistPortalCardState } from '../../../smartLinks/catalog/artistPortalCardState';

/**
 * No artist portal is connected yet. Artist Home reads it (the Streams row). The navigation no
 * longer shows it: the Catalog badge covers the setup (design your-intelligence h2).
 *
 * It reads the connection cards the Catalog reads (`GET /accounts/:id/service-connections`). A
 * portal counts as set up once the artist signed in to it, even if the session later expired or
 * the artist still has to pick one: the dot marks a first setup, not a broken one. `false` until
 * the list loads, so the dot never flashes.
 */
export function usePortalSetupNeeded(accountId: number | null): boolean {
  const { data } = useGetServiceConnectionsQuery({ accountId: accountId ?? 0 }, { skip: accountId === null });

  return useMemo(() => {
    if (data === undefined) {
      return false;
    }
    return data.connections.every((connection) => artistPortalCardState(connection) === ArtistPortalCardState.none);
  }, [data]);
}
